import { render, staticRenderFns } from "./StatsFittingShop.vue?vue&type=template&id=71fe7187&"
import script from "./StatsFittingShop.vue?vue&type=script&lang=js&"
export * from "./StatsFittingShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports